import {mapFields} from "vuex-map-fields";

export default {
    data() {
        return {
            tdConversionFired: false,
        };
    },

    computed: {
        ...mapFields([
            'round2.complaint.id',
            'round2.complaint.affiliate_tracked',
            'round2.complaint.least_one_poa_signed',
            'round2.complaint.travel_plan_ok',
        ]),

        tradedoublerConfig() {
            const host = window.location.host;

            if (host.includes("flyforsinkelse.dk")) {
                return { eventId: 468527, fallbackUrl: "https://a.tdguard.eu/trsdk" };
            }

            if (host.includes("flyforsinkelser.no")) {
                return { eventId: 468527, fallbackUrl: "https://a.imgstatics.com/trsdk" };
            }

            if (host.includes("flygforsening.se")) {
                return { eventId: 468527, fallbackUrl: "https://a.img-statics.com/trsdk" };
            }

            if (host.includes("peruutetutlennot.fi")) {
                return { eventId: 468527, fallbackUrl: "https://a.tdguard.eu/trsdk" };
            }

            if (host.includes("zpozdeno.cz")) {
                return { eventId: 468527, fallbackUrl: "https://a.imgstatics.com/trsdk" };
            }

            if (host.includes("zwrotzalot.pl")) {
                return { eventId: 468527, fallbackUrl: "https://a.tdimage.nl/trsdk" };
            }

            if (host.includes("flugrueckerstattung.de")) {
                return { eventId: 468527, fallbackUrl: "https://a.img-statics.com/trsdk" };
            }

            // fallback
            return { eventId: null, fallbackUrl: null };
        },

        hasTradedoublerAttribution() {
            return document.cookie.includes("affiliate_source=trade_doubler") || // TODO: remove later | for previous logic
                document.cookie.includes("FF_CT_affiliate_source=trade_doubler");
        },

        shouldFireTradedoubler() {
            if (!this.hasTradedoublerAttribution) return false;
            if (!this.tradedoublerConfig.eventId) return false;
            if (!this.id) return false;
            if (this.affiliate_tracked) return false;
            if (!this.least_one_poa_signed) return false;
            if (!this.travel_plan_ok) return false;
            if (this.tdConversionFired) return false;

            return true;
        },
        transactionId() {
            return this.id;
        }
    },

    methods: {
        async fireTradedoublerConversionIfNeed() {
            if (!this.shouldFireTradedoubler) return;
            if (typeof window === "undefined") return;
            if (typeof window.tdconv !== "function") {
                console.warn("Tradedoubler SDK tdconv not loaded");
                return;
            }

            const cfg = this.tradedoublerConfig;

            if (!cfg.eventId) {
                console.warn("Tradedoubler config not found for this domain");
                return;
            }

            const TDConversion = {
                transactionId: String(this.transactionId),
                event: cfg.eventId,
                // voucher: '[VOUCHER]'
            };

            try {
                window.tdconv("track", "lead", TDConversion);

                if (cfg.fallbackUrl) {
                    if (typeof window.tdfallback === "function") {
                        window.tdfallback(cfg.fallbackUrl);
                    } else {
                        const s = document.createElement("script");
                        s.async = true;
                        s.src = cfg.fallbackUrl;
                        document.head.appendChild(s);
                    }
                }

                this.tdConversionFired = true;
                await this.markTDComplaintAffiliateTracked()

                console.log("Tradedoubler conversion fired", TDConversion);
            } catch (err) {
                console.error("Tradedoubler conversion error:", err);
            }
        },
        async markTDComplaintAffiliateTracked() {
            this.$store.commit('round2/UPDATE_COMPLAINT_FIELD', { path: 'affiliate_tracked', value: true })

            let formData = new FormData()
            formData.append(`complaint[affiliate_tracked]`, 'true')
            await this.$store.dispatch("round2/putComplaint", formData)
        }
    },
};